module.exports = __webpack_public_path__ + "static/media/checked-hex.b4dc8557.svg";